import React from "react";
import { Input } from "@/components/ui/input";
import { Field, NativeSelect } from "@/components/visit/VisitBits";
import PhotoUploader from "@/components/visit/PhotoUploader";
import { LAND_RATE_SOURCES, sectionFiles, setPath } from "@/lib/visitSchema";

export default function LandRateStep({ form, setForm, uploads }) {
  const set = (path) => (v) => setForm((prev) => setPath(prev, path, v?.target ? v.target.value : v));
  return (
    <div className="space-y-4" data-testid="visit-step-land-rate-panel">
      <p className="text-xs text-slate-500">Capture who confirmed the prevailing local market rate and attach proof (rate slip, broker card, recent sale deed, etc.).</p>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
        <Field label="Source type"><NativeSelect value={form.land_rate.source_type} onChange={set("land_rate.source_type")} options={LAND_RATE_SOURCES} placeholder="Broker / Local reference" testId="visit-land-source-type" /></Field>
        <Field label="Broker / reference name"><Input value={form.land_rate.source_name} onChange={set("land_rate.source_name")} data-testid="visit-land-source-name" /></Field>
        <Field label="Phone number"><Input type="tel" inputMode="numeric" value={form.land_rate.source_phone} onChange={set("land_rate.source_phone")} data-testid="visit-land-source-phone" /></Field>
      </div>
      <PhotoUploader section="land_rate" label="Land rate verification photo / supporting document" accept="image/*,application/pdf"
        files={sectionFiles(form, "land_rate")} uploads={uploads} testId="visit-upload-land-rate" />
    </div>
  );
}
